import trackingSettingsSagas from './tracking-settings.sagas';

export default trackingSettingsSagas;
